<template>
  <th
    :style="styles"
    @click="onSort"
    class="sortable"
    :class="{ active: isActive }"
  >
    <div class="d-flex flex-row justify-content-start align-items-center">
      <slot></slot>
      <span v-if="isActive" class="ml-2">
        <font-awesome-icon
          :icon="['fa', isDesc ? 'caret-down' : 'caret-up']"
          class="ms-1"
        />
      </span>
      <span
        v-else
        class="d-flex flex-row ml-2 align-items-center justify-content-end"
      >
        <font-awesome-icon :icon="['fa', 'caret-up']" class="ms-1 text-muted" />
        <font-awesome-icon
          :icon="['fa', 'caret-down']"
          class="ms-1 text-muted"
        />
      </span>
    </div>
  </th>
</template>

<script>
export default {
  name: "SortableHeader",
  props: {
    param: { type: String, required: true },
    ordering: { type: Object, required: true },
    styles: { type: [String, Object], default: "" },
  },
  computed: {
    isActive() {
      return (
        this.ordering.term && this.ordering.term.replace("-", "") === this.param
      );
    },
    isDesc() {
      return this.ordering.term && this.ordering.term.startsWith("-");
    },
  },
  methods: {
    onSort() {
      this.$emit("sort", this.param);
    },
  },
};
</script>
